import styled from 'styled-components';
import { ToggleBoldButton } from './ToggleBoldButton';
import { ToggleItalicButton } from './ToggleItalicButton';
import { ToggleUnderlineButton } from './ToggleUnderlineButton';
import { ToggleLinkButton } from './ToggleLinkButton';
import { ToggleSnippetPickerButton } from './ToggleSnippetPickerButton';
import { ToggleMergeTagMenuButton } from './ToggleMergeTagMenuButton';
import { ContentType } from '../../../../../types';
import { useDynamicContentContext } from '../../../../../contexts';

const Wrapper = styled.div`
  padding: 5px;
  cursor: default;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
`;

const Divider = styled.div`
  background-color: #d6d6d6;
  width: ${({ theme }) => theme.spacing.values.single};
  margin: ${({ theme }) => theme.spacing.values.half}
    ${({ theme }) => theme.spacing.values.threeQuarter};
`;

export const Toolbar = () => {
  const { contentType } = useDynamicContentContext();
  const canUseFormatting = contentType === ContentType.html;

  return (
    <Wrapper>
      <ToggleSnippetPickerButton />
      <ToggleMergeTagMenuButton />
      {canUseFormatting && (
        <>
          <Divider />
          <ToggleBoldButton />
          <ToggleItalicButton />
          <ToggleUnderlineButton />
          <ToggleLinkButton />
        </>
      )}
    </Wrapper>
  );
};
